// The action-type dropdown and the edited `actions` are separate pieces of editor state, and each
// action editor only writes `actions` when the user edits one of its fields. So when the type
// changes, `actions` has to be rebuilt for it right away: otherwise the previous action is what
// gets validated and saved. That was GR-10711 - switching "Assign" to "Notify practice" kept the
// assign action, whose `note` made the notify-practice validation pass, and the rule saved unchanged.
export const getActionsForActionType = ({ actions, actionType, savedActions = [], isTimeBased = false }) => {
  if (actions?.[0]?.type === actionType) {
    return actions
  }

  // executionHour belongs to the rule's schedule rather than to the action, so it survives the switch.
  const executionHour = isTimeBased ? actions?.[0]?.params?.executionHour : undefined

  // Switching back to the rule's saved type restores what was saved instead of an empty action,
  // keeping an hour the user may have changed in the meantime.
  if (savedActions?.[0]?.type === actionType) {
    if (!executionHour) {
      return savedActions
    }

    const [savedAction, ...rest] = savedActions
    return [{ ...savedAction, params: { ...savedAction.params, executionHour } }, ...rest]
  }

  return [{ type: actionType, params: executionHour ? { executionHour } : {} }]
}
